























































































































































import { addItemsToListIfAreNotAdded, removeItemsFromList } from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MultipleSelect, MsgBox } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import ConfirmAction from '../../core/components/ConfirmAction.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { NormsServices } from '../../norms/api/NormsServices';
import VariableClasification from '../models/VariableClasification';
import { formatDate } from '../../core/utils';
import { SettingsService } from '../api/SettingsService';
import Loading from 'vue-loading-overlay';
import Input from '../../core/components/Input.vue';
@Component({
    components: { MultipleSelect, Loading, MsgBox, TableArrows, SimpleTable, ConfirmAction, SectionTitle, Input }
})
export default class VariableGroupConfiguration extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({ default: () => {} })
    vehicleToEditId: string;
    @Prop() variableConfigurationList: any[];
    @Prop() waitingVariableConfigurationList: boolean;

    parameterVersionList: any[] = [];

    searchVar: string = '';
    searchVarInGroup: string = '';

    availableSelectedVariables: Array<object> = [];
    availableVariablesSelected: Array<object> = [];
    searchavailableVariables: string = '';
    availableVehicles: Array<object> = [];
    loadingAvailableVariables: boolean = false;
    selectedVariables: any[] = [];

    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [false];

    visiblePatchConfirmAction: boolean = false;
    pendingRequest: boolean = false;
    isSelection: boolean = false;
    itemToAddOrRemove: any = {};

    get selectedVariablesAreValid(){
        return this.selectedVariables.length < 30 ? true : false
    }

    get headersSelectedVariables() {
        return [
            {
                text: '#Ecu',
                value: 'ecu',
                sortable: true,
                width: '85px'
            },
            {
                text: 'Variable',
                value: 'variable',
                width: '300px',
                sortable: true
            },
            {
                text: 'Clasificación',
                value: 'classification',
                sortable: true
            }
        ];
    }

    updateSearchValInGroup(value){
        this.searchVarInGroup = value;
    }

    patchVariableConfiguration() {
        this.sendDataToParent();
        this.$emit('patchVariableConfiguration');
    }

    async getParameterVersionList() {
        try {
            this.loadingAvailableVariables = true;
            const response = await NormsServices.getParameterVersionList(this.vehicleToEditId);
            this.parameterVersionList = response;
            this.removeSelectedVariableFromMainList(this.selectedVariables);
            this.loadingAvailableVariables = false;
        } catch (e) {
            this.$_showHistoricalError(e);
            this.loadingAvailableVariables = false;
        }
    }

    moveVariableToTheRight() {
        this.selectedVariables = addItemsToListIfAreNotAdded(
            this.selectedVariables,
            this.availableVariablesSelected,
            'id'
        );

        this.removeSelectedVariableFromMainList(this.selectedVariables);
        this.availableVariablesSelected = [];
    }

    moveVariableToTheLeft() {
        this.removeSelectedVehicle();
    }

    updateavailableVariablesSelected(rows) {
        this.availableVariablesSelected = rows;
    }

    removeSelectedVariableFromMainList(itemsToExclude) {
        this.parameterVersionList = removeItemsFromList(this.parameterVersionList, itemsToExclude, 'id');
        this.availableSelectedVariables = [];
    }

    removeSelectedVehicle() {
        this.parameterVersionList = addItemsToListIfAreNotAdded(
            this.parameterVersionList,
            this.availableSelectedVariables,
            'id'
        );
        this.selectedVariables = removeItemsFromList(this.selectedVariables, this.availableSelectedVariables, 'id');
        this.availableSelectedVariables = [];
    }

    updateSelectedVariables(rows) {
        this.availableSelectedVariables = rows;
    }

    get headersAvailableVariables() {
        return [
            {
                text: '#Ecu',
                value: 'ecu',
                sortable: true,
                width: '85px'
            },
            {
                text: 'Variable',
                value: 'variable',
                width: '300px',
                sortable: true
            },
            {
                text: 'Clasificación',
                value: 'classification',
                sortable: true
            }
        ];
    }

    modalWidth: string = '1700';

    nameRules: any = [v => !!v || 'Debe ingresar el nombre', v => (v && v.length >= 1) || 'Debe ingresar el nombre'];

    processingRequest: boolean = false;
    valid: boolean = false;

    mounted() {
        this.getParameterVersionList();
        this.loadModalData();
    }

    updateSearchValue(value){
        this.searchVar = value;
    }

    // @Watch('visible')
    loadModalData() {
        if (this.parameterVersionList !== null) {
            this.selectedVariables = this.variableConfigurationList.filter(
                variable => variable.can_be_deactivated == true
            );
        } else {
            this.selectedVariables = [];
        }
    }

    format(date: string) {
        return formatDate(date);
    }

    sendDataToParent() {
        let parameterVersionList: any = {
            parameter_version_list: this.selectedVariables.map(variable => variable.id)
        };
        this.$emit('submit', parameterVersionList);
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });

        return uniqueObject;
    }

    @Emit()
    closeDialog(action: boolean, variableGroup: any) {}
}
